import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import ReactDOM from 'react-dom'

export interface IPageActionsProps {}

export const PageActions = ({
  children,
}: PropsWithChildren<IPageActionsProps>) => {
  const [pageActionContainer, setPageActionContainer] =
    useState<Element | null>(null)

  useEffect(() => {
    setPageActionContainer(document.querySelector('#page-action-container'))
  }, [])

  return pageActionContainer ? (
    ReactDOM.createPortal(children, pageActionContainer)
  ) : (
    <>{children}</>
  )
}

PageActions.displayName = 'PageActions'
